var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / note-add Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.05,2.5 C6.80833333,2.38333333 3.33333333,5.79166667 3.33333333,10 L1.84166667,10 C1.46666667,10 1.28333333,10.45 1.55,10.7083333 L3.875,13.0416667 C4.04166667,13.2083333 4.3,13.2083333 4.46666667,13.0416667 L6.79166667,10.7083333 C7.05,10.45 6.86666667,10 6.49166667,10 L5,10 C5,6.75 7.65,4.125 10.9166667,4.16666667 C14.0166667,4.20833333 16.625,6.81666667 16.6666667,9.91666667 C16.7083333,13.175 14.0833333,15.8333333 10.8333333,15.8333333 C9.49166667,15.8333333 8.25,15.375 7.26666667,14.6 C6.93333333,14.3416667 6.46666667,14.3666667 6.16666667,14.6666667 C5.81666667,15.0166667 5.84166667,15.6083333 6.23333333,15.9083333 C7.5,16.9083333 9.09166667,17.5 10.8333333,17.5 C15.0416667,17.5 18.45,14.025 18.3333333,9.78333333 C18.225,5.875 14.9583333,2.60833333 11.05,2.5 Z M10.625,6.66666667 C10.2833333,6.66666667 10,6.95 10,7.29166667 L10,10.3583333 C10,10.65 10.1583333,10.925 10.4083333,11.075 L13.0083333,12.6166667 C13.3083333,12.7916667 13.6916667,12.6916667 13.8666667,12.4 C14.0416667,12.1 13.9416667,11.7166667 13.65,11.5416667 L11.25,10.1166667 L11.25,7.28333333 C11.25,6.95 10.9666667,6.66666667 10.625,6.66666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar-/-Closed-/-01-Default",
    transform: "translate(-38.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 180.000000)",
    id: "Icon-/-note-add-Copy-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#848484",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.25d7a268ac6d62904ff2c00ae22e4da2.svg";
export { ForwardRef as ReactComponent };